import { Injectable } from '@angular/core';
import { path_file } from '@app/config/path-file.enum';
import { Storage, ref, getDownloadURL, uploadBytesResumable } from '@angular/fire/storage'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private storage: Storage, private http: HttpClient,) { }


  getDownloadURL(pathFile: path_file, fileName: any) {
    return getDownloadURL(ref(this.storage, pathFile + fileName));
  }

  downloadFileEmployeeEducation(fileName: string) {
    this.getDownloadURL(path_file.EmployeeEducation, fileName).then(url => {
      this.downloadFile(url, 'Diploma')
    })
  }

  downloadFileEmployerProtocol(filePath: string, fileName: string) {
    this.getDownloadURL(path_file.ComplaintProtocol, filePath).then(url => {
      this.downloadFile(url, fileName)
    })
  }

  downloadFileEmployerDocument(filePath: string, fileName: string) {
    this.getDownloadURL(path_file.ComplaintDocument, filePath).then(url => {
      this.downloadFile(url, fileName)
    })
  }

  downloadFileEmployeeTraining(fileName: string) {
    this.getDownloadURL(path_file.EmployeeTraining, fileName).then(url => {
      this.downloadFile(url, 'Diploma')
    })
  }

  downloadFileEmployeeLanguage(fileName: string) {
    this.getDownloadURL(path_file.EmployeeLanguage, fileName).then(url => {
      this.downloadFile(url, 'Diploma')
    })
  }

  downloadReportInterview(fileName: string, fileDownloadName: string = null) {
    this.getDownloadURL(path_file.EmployeeInterviewReport, fileName).then(url => {
      this.downloadFile(url, fileDownloadName)
    })
  }

  downloadReportInterviewMinified(fileName: string, fileDownloadName: string = null) {
    this.getDownloadURL(path_file.EmployeeInterviewReportMinified, fileName).then(url => {
      this.downloadFile(url, fileDownloadName)
    })
  }

  downloadFileEmployeeWwcRecord(fileName: string) {
    this.getDownloadURL(path_file.EmployeeWwcRecord, fileName).then(url => {
      this.downloadFile(url, 'Certificado')
    })
  }

  downloadFileEmployeeCriminalRecord(fileName: string) {
    this.getDownloadURL(path_file.EmployeeCriminalRecord, fileName).then(url => {
      this.downloadFile(url, 'Certificado')
    })
  }

  downloadFileEmployeeDisabilityRecord(fileName: string) {
    this.getDownloadURL(path_file.EmployeeDisabilityRecord, fileName).then(url => {
      this.downloadFile(url, 'Certificado')
    })
  }

  downloadFileCourseProgram(fileName: string) {
    this.getDownloadURL(path_file.EmployeeCriminalRecord, fileName).then(url => {
      this.downloadFile(url, 'Programa')
    })
  }

  downloadEmployeeCertificateDisabilities(fileName: string, fileDownloadName: string) {
    this.getDownloadURL(path_file.EmployeeCertificate, fileName).then(async url => {

      const response = await fetch(url);

      const blob = await response.blob();

      saveAs(blob, fileDownloadName);
    })
  }

  /**
   * 
   * @param url entire path to the file
   */
  async downloadFileEducationalProyect(fileName: string) {

    let fullPath: string = fileName;

    await this.getDownloadURL(path_file.EmployerProject, fileName).then(url => {
      fullPath = url;
    }, () => {
      fullPath = fileName;
    })

    this.downloadFile(fullPath, 'Proyecto Educativo');
  }

  uploadPhotoEmployer(filestr: string) {



    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }

    const _id = result;
    const refStorage = ref(this.storage, path_file.UserPhoto + _id);
    return uploadBytesResumable(refStorage, this.dataURItoBlob(filestr));
  }

  dataURItoBlob(dataURI) {

    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;

  }

  uploadFile(file: File, _id: any, path: any) {
    const metaData = { 'contentType': file.type }
    const refStorage = ref(this.storage, path + _id);
    return uploadBytesResumable(refStorage, file, metaData)
  }

  uploadPhoto(filestr: string, _id: any, path: any) {
    const refStorage = ref(this.storage, path + _id);
    return uploadBytesResumable(refStorage, this.dataURItoBlob(filestr));
  }

  downloadFile(route: string, filename: string = null): void {

    const token = 'my JWT';
    const headers = new HttpHeaders().set('authorization', 'Bearer ' + token);
    this.http.get(route, { headers, responseType: 'blob' as 'json' }).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);


        // Lista de MIME types que corresponden a archivos PDF
        /* const pdfMimeTypes = [
          'application/pdf',
          'application/x-pdf',
          'application/acrobat',
          'applications/vnd.pdf',
          'text/pdf',
          'text/x-pdf'
        ];


        // Verifica si el dataType está en la lista de MIME types
        // if (pdfMimeTypes.includes(dataType)) {

         const pdfBlob = new Blob(binaryData, { type: dataType });

         // Utilizar FileReader para convertir el Blob a una cadena base64
         const reader = new FileReader();

         reader.onloadend = function () {
           // Obtener la cadena base64 del PDF
           const pdfDataUrl = reader.result;

           // Abrir una nueva pestaña
           const newTab = window.open();

           // Crear el contenido HTML con el PDF incrustado
           let strDocument = `<html><head><title>${filename}</title></head><body style="margin:0"><embed src="`;
           strDocument += pdfDataUrl;
           strDocument += `" type="application/pdf" width="100%" height="100%" /></body></html>`;

           // Escribir el contenido en la nueva pestaña
           newTab.document.write(strDocument);
           newTab.document.close();
         };

         // Leer el Blob como Data URL (base64)
         reader.readAsDataURL(pdfBlob);*/


        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));

        if (filename)
          downloadLink.setAttribute('download', filename);

        document.body.appendChild(downloadLink);
        downloadLink.click();

      }
    )
  }
}
